import { Modal } from "antd";

const LoginFail = (handleClick, content) => {
  {
    const { error } = Modal;
    return error({
      title: "Login failed",
      content: content,
      okText: "Yes",
      okType: "danger",

      visible: true,
      maskClosable: true,
      onOk() {
        handleClick();
      },
    });
  }
};
export default LoginFail;
